
export enum JOB_STATUSES {
  PENDING = 'pending',
  UPLOADED_CSV = 'csv uploaded',
  VALIDATION_FAILED = 'csv validation failed',
  VALIDATION_SUCCESS = 'csv validated',
  DONE = 'done',
  TRANSFORMED = 'transformed',
  TRANSFORMING = 'transforming',
  FAILED = 'failed'
}
